import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CalculatorPageDetailModel } from 'Core/models/CalculatorPageDetailModel';
import { EnvironmentService } from 'Core/services/environment.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  // private readonly API_URL = `https://api.bath-dream.ru`;
  private readonly API_URL;

  constructor(
    private http: HttpClient,
    private envService: EnvironmentService,
  ) {
    this.API_URL = envService.getValue('apiUrl');
  }

  getHeadersWithoutToken() {
    let headers: any;
    headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('Accept', '*/*');
    headers = headers.set('Accept-Encoding', 'gzip', 'deflate', 'br');
    return headers;
  }

  getHeaders() {
    let headers: any;
    headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    return headers;
  }

  getHeaders2() {
    let headers: any;
    headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('Accept', '*/*');
    return headers;
  }

  getHeaderFormData() {
    let headers: any;
    headers = new HttpHeaders();

    return headers;
  }

  post(path: string, body = {}): Observable<any> {
    return this.http.post(this.API_URL + path, body, {
      headers: this.getHeaders(),
      responseType: 'json',
    });
  }

  postT<T>(path: string, body = {}): Observable<T> {
    return this.http.post<T>(this.API_URL + path, body, {
      headers: this.getHeaders(),
      responseType: 'json',
    });
  }

  post3(path: string, body): Observable<any> {
    return this.http.post(this.API_URL + path, body, {
      headers: this.getHeaders(),
      responseType: 'json',
    });
  }

  post4(path: string, body): Observable<any> {
    return this.http.post(this.API_URL + path, body, {
      headers: this.getHeaders2(),
      responseType: 'json',
    });
  }

  post2(path: string, body = {}): Observable<any> {
    return this.http.post(this.API_URL + path, body, {
      headers: this.getHeaderFormData(),
      responseType: 'text',
    });
  }

  postBlob(path: string, body = {}): Observable<any> {
    return this.http.post(this.API_URL + path, body, {
      headers: this.getHeaderFormData(),
      responseType: 'blob' as 'json',
    });
  }

  patch(path: string, body = {}): Observable<any> {
    return this.http.patch(this.API_URL + path, body, {
      headers: this.getHeaders(),
      responseType: 'json',
    });
  }

  delete(
    path: string,
    newParams: HttpParams = new HttpParams(),
  ): Observable<any> {
    return this.http.delete(this.API_URL + path, {
      responseType: 'json',
      params: newParams,
    });
  }

  get(path: string, newParams: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(this.API_URL + path, {
      params: newParams,
      responseType: 'json',
    });
  }

  getT<T>(
    path: string,
    newParams: HttpParams = new HttpParams(),
  ): Observable<T> {
    return this.http.get<T>(this.API_URL + path, {
      params: newParams,
      responseType: 'json',
    });
  }

  get2(
    path: string,
    newParams: HttpParams = new HttpParams(),
  ): Observable<any> {
    return this.http.get(this.API_URL + path, {
      params: newParams,
      responseType: 'text',
    });
  }

  putT(path: string, body = {}): Observable<any> {
    return this.http.put(this.API_URL + path, body, {
      responseType: 'json',
    });
  }

  put<T>(path: string, body = {}): Observable<T> {
    return this.http.put<T>(this.API_URL + path, body, {
      responseType: 'json',
    });
  }

  put2(path: string, body: FormData): Observable<any> {
    return this.http.put(this.API_URL + path, body);
  }

  delete2(path: string, body = {}): Observable<any> {
    return this.http.delete(this.API_URL + path, {
      body: body,
      responseType: 'json',
    });
  }

  patchWithoutToken(path: string, body: Object = {}): Observable<any> {
    return this.http.patch(path, body, {
      headers: this.getHeadersWithoutToken(),
      responseType: 'json',
    });
  }
}
